import { ManualNotificationQueuesStatusType } from '@golden/gdk-admin'

const manualNotificationQueuesStatusColor: { [key in ManualNotificationQueuesStatusType]: string } = {
  [ManualNotificationQueuesStatusType.WAITING]: '#808080',
  [ManualNotificationQueuesStatusType.PROCESSING]: '#72d476',
  [ManualNotificationQueuesStatusType.FAILED]: '#ff5f5f'
}

export default manualNotificationQueuesStatusColor
